import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {SharedModule} from '../../shared/shared.module';
import {TestdriveRoutingModule} from './testdrive-routing.module';
import {TestdriveComponent} from './testdrive.component';
import {BdcSharedModule} from '../shared/bdc-shared.module';
import { ConfirmInfoComponent } from './confirm-info/confirm-info.component';


@NgModule({
  declarations: [
    TestdriveComponent,
    ConfirmInfoComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BdcSharedModule,
    TestdriveRoutingModule
  ]
})
export class TestdriveModule { }
